export const LINK = {
  // 特定商取引法&資金決済法
  SPECIFIED_COMMERCIAL_TRANSACTION_LAW_AND_FUND_SETTLEMENT_ACT:
    "https://onereco.jp/tokusho/",
};
